import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  'ol',
  'ul',
  'li',
  'a',
  'code',
  'pre',
  'blockquote',
  'h2',
  'h3',
];

const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeBodyHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
